// extracted by mini-css-extract-plugin
module.exports = {"img":"ProductTypeIcon_img__MEo8o"};